import axiosMain from 'axios';
import { getGlidePath } from '../helpers/glide-path';

const glidePath = getGlidePath();

const axiosIntstance = axiosMain.create({
  baseURL: glidePath,
});

// Axios instance
export const axios = axiosIntstance;

export const setAuthorizationHeader = (token = null) => {
  if (token) {
    axiosIntstance.defaults.headers.common.authorization = `Bearer ${token}`;
  } else {
    delete axiosIntstance.defaults.headers.common.authorization;
  }
};
